"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentMethods = exports.MomentDateFormat = exports.InvoiceStatuses = exports.FilenameDateFormat = exports.DateTimeWithoutYear = exports.DateTimeFormat = exports.DateFormat = exports.DUPLICATE_INVOICE_WINDOW = void 0;
const InvoiceStatuses = exports.InvoiceStatuses = {
  CANCELLED: "cancelled",
  DRAFT: "draft",
  READY_FOR_PICK: "ready_for_pick",
  PICK_COMPLETE: "pick_complete",
  READY_FOR_TABC_STAMPS: "ready_for_tabc_stamps",
  PARTIALLY_PAID: "partially_paid",
  PAID: "paid",
  INVOICED: "invoiced",
  DELIVERED: "delivered",
  PICKED_UP: "picked_up",
  PAYMENT_DUE_SOON: "payment_due_soon",
  PAYMENT_DUE: "payment_due"
};
const PaymentMethods = exports.PaymentMethods = {
  CHECK: "CK",
  FINTECH: "FT",
  PREPAID: "PP",
  CASH: "CH"
};
const FilenameDateFormat = exports.FilenameDateFormat = "dd_MMM_yyyy";
const DateFormat = exports.DateFormat = "dd MMM, yyyy";
const DateTimeFormat = exports.DateTimeFormat = "dd MMM, yyyy hh:mm a";
const MomentDateFormat = exports.MomentDateFormat = "YYYY-MM-DD";
const DateTimeWithoutYear = exports.DateTimeWithoutYear = "dd MMM hh:mm a";
// Threshold to use to check duplicate invoices
const DUPLICATE_INVOICE_WINDOW = exports.DUPLICATE_INVOICE_WINDOW = 24;